"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.XErrorFromLib = exports.MakeSMessageError = exports.validateResponse = void 0;
var core_1 = require("@eres/core");
function validateResponse(response, errorListKey) {
    if (errorListKey === void 0) { errorListKey = "ValidationErrorsList"; }
    if (response == undefined)
        return Promise.reject("Empty response");
    if (response.Code !== 0 && "" + response.Code !== "0") {
        var reason = response.Message;
        if (response.Response) {
            var r = response.Response;
            var errorList = r[errorListKey];
            if (errorList && Array.isArray(errorList) && errorList.length > 0) {
                reason = errorList.reduce(function (pv, cv) {
                    var msg = {
                        en: cv.ErrorMessage,
                        ar: cv.ErrorMessageAr,
                    };
                    var m = core_1.LocaleUtil.getLocalValue(msg);
                    var e = pv;
                    if (!core_1.StringUtil.isEmptyStringOrNull(m)) {
                        e = e + "\n" + m;
                    }
                    return e;
                }, "").trim();
            }
        }
        return Promise.reject(reason);
    }
    return Promise.resolve(response.Response);
}
exports.validateResponse = validateResponse;
function MakeSMessageError(message, info, messageId) {
    var e = new XErrorFromLib();
    if (message)
        e.message = message;
    if (info)
        e.info = info;
    if (messageId)
        e.messageId = messageId;
    return e;
}
exports.MakeSMessageError = MakeSMessageError;
var XErrorFromLib = /** @class */ (function (_super) {
    __extends(XErrorFromLib, _super);
    function XErrorFromLib() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.xType = "XErrorFromLib";
        return _this;
    }
    return XErrorFromLib;
}(Error));
exports.XErrorFromLib = XErrorFromLib;
